var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 55,
    viewBox: "0 0 55 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 60
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 60,
    fill: "#fff",
    style: {
      fillOpacity: 0
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility",
    transform: "translate(10.5 -86.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 106.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M33.874,116.176c-.268-.39-6.7-9.514-16.874-9.514-8.728,0-16.506,9.072-16.833,9.459a.711.711,0,0,0,0,.915c.327.387,8.1,9.459,16.833,9.459s16.506-9.072,16.833-9.459A.708.708,0,0,0,33.874,116.176ZM17,125.079c-7,0-13.65-6.673-15.34-8.5,1.687-1.829,8.333-8.5,15.34-8.5,8.187,0,13.966,6.663,15.377,8.462C30.747,118.31,24.057,125.079,17,125.079Z",
    transform: "translate(0 -106.662)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(11.333 110.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M176.329,170.662A5.667,5.667,0,1,0,182,176.329,5.672,5.672,0,0,0,176.329,170.662Zm0,9.917a4.25,4.25,0,1,1,4.25-4.25A4.255,4.255,0,0,1,176.329,180.579Z",
    transform: "translate(-170.662 -170.662)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.337370d8b7e1bf46e696497e920e80fa.svg";
export { ForwardRef as ReactComponent };